import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash';
import Pficon from 'components/Pficon';
import { FormattedMessage } from 'react-intl';
import SelectedIndicator from 'containers/CreateSurveyModal/SelectedIndicator';
import { LETS_TALK_ELITE_URL } from 'containers/App/constants';
import messages from '../messages';

const CardTypeButton = (props) => {
  const {
    title,
    titleClassName = 'text-size-18 margin-btm-xs color-grey-10 font-bold',
    description,
    descriptionClassName,
    onClick,
    className = '',
    disabled = false,
    selected = false,
  } = props;

  const [linkVisible, setLinkVisible] = useState(false);

  const renderContent = () => (
    <button
      type="button"
      className={classNames(
        'flex flex-justify-between flex-align-items--center',
        'w-full',
        'outline-none',
        'outline-blue',
        'border-radius-level-1',
        'text-align-left',
        { 'cursor-pointer': !disabled },
        'padding-lg',
        'position-relative',
        'border-grey-1',
        'create-survey-card',
        { 'create-survey-card-selected': selected },
        className,
      )}
      style={
        selected
          ? { zIndex: 1, boxShadow: '2px 8px 20px 0 rgba(50, 57, 69, 0.1)' }
          : {}
      }
      onClick={disabled ? noop : onClick}
    >
      <div style={{ width: '500px' }}>
        <h3 className={titleClassName}>{title}</h3>
        <div className={descriptionClassName}>{description}</div>
      </div>
      {!disabled && (
        <div className="margin-right-sm">
          <SelectedIndicator selected={selected} />
        </div>
      )}
      {disabled && !linkVisible && (
        <Pficon
          className="position-absolute color-grey-10"
          size={24}
          type="lock3"
          style={{
            zIndex: 10,
            top: '50%',
            transform: 'translate3d(0, -25%, 0)',
            right: '33px',
            marginTop: '-4px',
          }}
        />
      )}
      {disabled && linkVisible && (
        <span
          className={classNames(
            'color-white',
            'color-white-hover',
            'padding-horizontal-md',
            'padding-vertical-xxs',
            'border-radius-level-1',
            'margin-right-xs',
          )}
          style={{ backgroundColor: '#20e27d' }}
        >
          <FormattedMessage {...messages.letsTalk} />
        </span>
      )}
    </button>
  );

  return (
    <div
      className="position-relative"
      onMouseEnter={() => setLinkVisible(true)}
      onMouseLeave={() => setLinkVisible(false)}
    >
      {disabled && (
        <a href={LETS_TALK_ELITE_URL} target="_blank">
          {renderContent()}
        </a>
      )}
      {!disabled && renderContent()}
    </div>
  );
};

CardTypeButton.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  description: PropTypes.any,
  descriptionClassName: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default CardTypeButton;
